<template>
  <div class="home">
     <App-navigation></App-navigation>
     <v-container grid-list-lg>

        <v-layout row>
            <v-flex  class="text-xs-center display-1 font-weight-black ">
               Welcome
            </v-flex>
            <v-text-field
              v-model="search"
              prepend-icon="search"
              append-icon="mic"
              label="Search"
              solo-inverted
              class="mx-2"
              flat

            ></v-text-field>

            
        </v-layout>
        <v-layout row wrap>
            <v-flex class="text-xs-center display-3 font-weight-black my-3" >
              <v-data-table :headers="headers" :items="Roles" :search="search" :custom-filter="customFilter" hide-actions class="elevation-1">
                <template slot="items" slot-scope="{item}">
                  <td><b>{{item.sn}}</b></td>
                  <td class="text-xs-center">{{item.name.toUpperCase()}}</td>
                  <td class="text-xs-center">{{item.desc.toUpperCase()}}</td>
                  <td class="text-xs-center">{{item.level.toUpperCase()}}</td>
                  
                </template>
              </v-data-table>

            </v-flex>
        </v-layout>
     </v-container>
     
  </div>
</template>

<script>
// @ is an alias to /src
import AppNavigation from '@/components/Navigation/AppNavigation.vue'
export default {
  name: 'staff',
  data(){
      return {
          //staff:{name:'Okoedo',gender:''},
          staff:this.$store.getters.getStaff,
          dialog:false,
          search:'',
          headers:[
            { 
              text:'S/N',
              align:'center',
              sortable:true,
              value:'sn'
            },
            {
              text:'NAME',
              align:'center',
              sortable:true,
              value:'name'
            },
            {
              text:'DESCRIPTION',
              align:'center',
              sortable:true,
              value:'desc'
            },
            {
              text:'LEVEL',
              align:'center',
              sortable:true,
              value:'level'
            }
          ],
          Roles:[
            { 
              sn:'1',
              name:'001',
              desc:'This will enable staff to be able to add a category',
              level:'Average',
              
            },
            { 
              sn:'2',
              name:'002',
              desc:'This will enable staff to be able to edit a category.',
              level:'Average',
              
            },
           { 
              sn:'3',
              name:'003',
              desc:'This will enable staff to be able to delete a category.',
              level:'Super',
              },
           { 
              sn:'4',
              name:'004',
              desc:'This will enable staff to be able to add a movie.',
              level:'Average',
              },
           { 
              sn:'5',
              name:'005',
              desc:'This will enable staff to be able to edit a movie.',
              level:'Average',
              },
           { 
              sn:'6',
              name:'006',
              desc:'This will enable staff to be able to sell a movie.',
              level:'Normal',
              },
           { 
              sn:'7',
              name:'007',
              desc:'This will enable staff to be able to delete a movie.',
              level:'Super',
              },
           { 
              sn:'8',
              name:'008',
              desc:'This will enable staff to be able to add a refreshment.',
              level:'Average',
              },
           { 
              sn:'9',
              name:'009',
              desc:'This will enable staff to be able to edit a refreshment.',
              level:'Average',
              },
           { 
              sn:'10',
              name:'010',
              desc:'This will enable staff to be able to sell a refreshment.',
              level:'Normal',
              },
           { 
              sn:'11',
              name:'011',
              desc:'This will enable staff to be able to delete a refreshment.',
              level:'Super',
              },
           { 
              sn:'12',
              name:'012',
              desc:'This will enable staff to be able to add a staff.',
              level:'Super',
              },
           { 
              sn:'13',
              name:'013',
              desc:'This will enable staff to be able to edit another staff details and privilege.',
              level:'Super',
              },
           { 
              sn:'14',
              name:'014',
              desc:'This will enable staff to be able to delete a staff.',
              level:'Super',
              },
           { 
              sn:'15',
              name:'015',
              desc:'This will enable staff to be able to delete a ticket.',
              level:'Super',
              },
           { 
              sn:'16',
              name:'016',
              desc:'This will enable staff to be able to add a campus.',
              level:'Average',
              },
           { 
              sn:'17',
              name:'017',
              desc:'This will enable staff to be able to edit a campus.',
              level:'Average',
              },
           { 
              sn:'18',
              name:'018',
              desc:'This will enable staff to be able to delete a campus.',
              level:'Super',
              },
           { 
              sn:'19',
              name:'019',
              desc:'This will enable staff to be able to link a movie to a campus.',
              level:'Average',
              },
           { 
              sn:'20',
              name:'020',
              desc:'This will enable staff to be able to remove a movie linked to a campus.',
              level:'Average',
              },
           { 
              sn:'21',
              name:'021',
              desc:'This will enable staff to be able to sell a movie linked to a campus.',
              level:'Normal',
              },
           { 
              sn:'22',
              name:'022',
              desc:'This will enable staff to be able to add a movie to watch now.',
              level:'Average',
              },
           { 
              sn:'23',
              name:'023',
              desc:'This will enable staff to be able to remove a movie from watch now.',
              level:'Average',
              }
          ],
          editedIndex:-1,
          editedItem:{
              name:''
          },
          defaultItem:{
              
          },
          listPrimitive:null
      }
  },
  methods:{
    customFilter(items,search){

     if(!search){ return items }
     function new_filter(val,search){
       return val !== null &&
        ['undefined','boolean'].indexOf(typeof val) === -1 &&
        val.toString().toLowerCase().replace( /[^0-9a-zA-Z]+/g ,'').indexOf(search) !== -1
     }

     let needleAry = search.toString().toLowerCase().split(" ").filter(x => x);

     return items.filter(row => needleAry.every(needle => Object.keys(row).some(key => new_filter(row[key],needle))));
    }
  },
  components: {
    AppNavigation,
  }
}
</script>
